// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"f0ed36e9","82":"0ce9961c","126":"12b5be7f","157":"654e8aee","248":"fc4645ba","386":"59a2e2be","446":"f8c63d54","626":"16477772","652":"082abae0","690":"292cc1dc","919":"2325297d","979":"cf73e0de","981":"8e8b38af"}[chunkId] + ".chunk.js";
};